/**
 * First screen for Clever Library onboarding.
 */
import {t} from "@lingui/core/macro";

import Button from "@khanacademy/wonder-blocks-button";
import {View} from "@khanacademy/wonder-blocks-core";
import {Strut} from "@khanacademy/wonder-blocks-layout";
import {spacing} from "@khanacademy/wonder-blocks-tokens";
import {HeadingMedium} from "@khanacademy/wonder-blocks-typography";

import {WELCOME_IMAGE_HEIGHT} from "../constants.ts";

interface Props {
    onChooseCreateAccount: () => void;
    onChooseLogin: () => void;
    /**
     * Optional identifier to use for the dialog title.
     *
     * Usefult for announcing the dialog to Screen Readers, as it will be used
     * as the `aria-labelledby` attribute of the dialog.
     */
    titleId?: string;
}

export default function WelcomeStep({
    onChooseCreateAccount,
    onChooseLogin,
    titleId,
}: Props) {
    return (
        <View>
            <Strut size={spacing.medium_16} />
            <HeadingMedium id={titleId}>
                {t`Welcome to Khan Academy!`}
            </HeadingMedium>
            <Strut size={spacing.xLarge_32} />
            <Button onClick={onChooseCreateAccount}>
                {t`Create a new account`}
            </Button>
            <Strut size={spacing.large_24} />
            <Button kind="tertiary" onClick={onChooseLogin}>
                {t`Log in to your existing account`}
            </Button>
            <Strut size={WELCOME_IMAGE_HEIGHT} />
        </View>
    );
}
